export const getEnvVars = key => {
  if (window && window.env && window.env[key]) {
    return window.env[key]
  }

  return process.env[key]
}

export const DEFAULT_PRICE = getEnvVars('REACT_APP_DEFAULT_PRICE_ID')
export const DEFAULT_CURRENCY = getEnvVars('REACT_APP_DEFAULT_CURRENCY_ID')
